import React from 'react';
import { Card, Badge } from 'nelitomorphism';
import './Education.css';

const SCHOOLS = [
  {
    school: 'Instituto Federal de Santa Catarina',
    url: 'https://ifsc.edu.br',
    course: 'Telecommunications Engineering',
    period: 'Jan 2013 — Dec 2017',
    location: 'Florianópolis',
    note: 'Incomplete',
    summary:
      'Electric and electronic systems, C, C++, Assembly, VHDL, networking, calculus, statistics, Linux and databases. Left to start working full time.',
  },
  {
    school: 'University of Debrecen',
    url: 'https://unideb.hu',
    course: 'Computer Science · Exchange student',
    period: 'Aug 2014 — Aug 2015',
    location: 'Debrecen, Hungary',
    summary:
      'Coursework in English across computer graphics, databases and OOP.',
  },
  {
    school: 'SENAI',
    url: 'https://sc.senai.br',
    course: 'Web Development · Technician',
    period: 'Jan 2011 — Dec 2012',
    location: 'São José, Brazil',
    summary:
      '1,600-hour program covering full-stack web development, hosting and internet fundamentals.',
  },
];

const Education = () => (
  <section id="education">
    <Card title="Education" meta="2011 — 2017">
      <ol className="edu-list">
        {SCHOOLS.map(s => (
          <li key={s.school} className="edu-item">
            <div className="edu-head">
              <h3 className="edu-school">
                <a href={s.url} target="_blank" rel="noopener noreferrer">
                  {s.school} ↗
                </a>
              </h3>
              {s.note && <Badge tone="warn">{s.note}</Badge>}
            </div>
            <p className="edu-course">{s.course}</p>
            <p className="edu-meta">
              {s.period} · {s.location}
            </p>
            <p className="edu-summary">{s.summary}</p>
          </li>
        ))}
      </ol>
    </Card>
  </section>
);

export default Education;
